<template>
  <footer :class="'footer-area footer-notin bg_color--' + 1" >
    <div class="footer-wrapper" v-if="NOTARIA && NOTARIA.Theme">
      <v-row align="end" class="row--0">
        <v-col md="6" sm="12" cols="12" v-if="NOTARIA.Theme.Footer.MostrarMapa">
          <div class="footer-left footer-left-notin" :style="footerLeftStyle">
            <div class="inner">
              <GoogleMap ref="mymap" api-key="AIzaSyCRbdQmLDJQz-JO8j3g_2J9yEOd27nJmvw"
                :center="{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng }" :zoom="15"
                map-type-id="roadmap" class="map-responsive" :options="gmapOptions">
                <Marker :options="{position:{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng },label:NOTARIA.Theme.Footer.PunteroMapa, title:NOTARIA.Nombre, clickable:true, draggable:false}"
                  @click="openWindow">
                  <InfoWindow @closeclick="window_open = false" :opened="window_open"
                    :options="{position:{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng},pixelOffset: {
                                  width: 0,
                                  height: -35
                                }
                              }">
                    <div style="color: #333 !important;">
                      <b>{{ NOTARIA.Nombre }}</b><br><br>
                      {{ NOTARIA.Contacto.Direccion }}<br>
                      {{ NOTARIA.Contacto.CP }}<br>
                      {{ NOTARIA.Contacto.Municipio }}, {{ NOTARIA.Contacto.Provincia }}<br><br>

                      <a :href="NOTARIA.Contacto.EnlaceMaps" target="_blank" style="color: #0000EE !important; text-decoration: underline;">Ver en Mapa</a>
                    </div>
                  </InfoWindow>
                </Marker>
              </GoogleMap>
            </div>
          </div>
        </v-col>
        <!-- End .col -->
        <v-col :md="colmd" sm="12" cols="12">
          <div class="footer-right footer-right-notin" :style="footerRightStyle">
            <v-row>
              <!-- Start Single Widget -->
              <v-col lg="6" sm="6" cols="12" class="mt_mobile--30">
               <div class="footer-widget">
                <b :style="tituloHorarioStyle">
                  {{ NOTARIA.Theme.Footer.TituloHorario.Texto }}
                </b>
                <ul>
                  <li :style="horarioStyle" v-html="NOTARIA.Contacto.Horario.replace(/(?:\r\n|\r|\n)/g, '<br>')">

                  </li>
                </ul> 
              </div>
              </v-col>
              <!-- End Single Widget  -->
              <!-- Start Single Widget -->
              <v-col lg="6" sm="6" cols="12">
                  <div class="footer-widget" :style="contactoStyle">
                    <b :style="tituloContactoStyle">
                      {{ NOTARIA.Theme.Footer.TituloDContacto.Texto }}
                    </b>
                  <ul class="ft-link">
                    <li v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Movil">
                      <v-icon class="mr-1" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">
                        mdi-phone
                      </v-icon>
                      <a v-if="NOTARIA.Contacto.Telefono" :style="contactoLinkStyle" :href="'tel:' + NOTARIA.Contacto.Telefono"
                        :title="'Marcar teléfono de la notaria: ' + NOTARIA.Contacto.Telefono">
                        {{ NOTARIA.Contacto.Telefono }}
                      </a>
                      <span v-if="NOTARIA.Contacto.Telefono && NOTARIA.Contacto.Movil" :style="contactoLinkStyle"> | </span>
                      <a v-if="NOTARIA.Contacto.Movil" :style="contactoLinkStyle" :href="'tel:' + NOTARIA.Contacto.Movil"
                        :title="'Marcar móvil de la notaria: ' + NOTARIA.Contacto.Movil">
                        {{ NOTARIA.Contacto.Movil }}
                      </a>
                    </li>
                    <li>
                      <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.EnlaceMaps" title="Abrir dirección de la notaria en google maps">
                        <v-icon class="mr-1" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">
                          mdi-map-marker
                        </v-icon>{{ NOTARIA.Contacto.Direccion }}
                        {{ NOTARIA.Contacto.CP }},
                        {{ NOTARIA.Contacto.Municipio }}, {{ NOTARIA.Contacto.Provincia }}
                      </a>
                    </li>
                    <li v-if="NOTARIA.Contacto.Email || NOTARIA.Contacto.Email2">
                      <v-icon class="mr-1" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">
                        mdi-email
                      </v-icon>
                      <a v-if="NOTARIA.Contacto.Email" :style="contactoLinkStyle" :href="'mailto:' + NOTARIA.Contacto.Email"
                        :title="'Enviar correo electronico a la dirección de la Notaria: ' + NOTARIA.Contacto.Email">
                        {{ NOTARIA.Contacto.Email }}
                      </a>
                      <span v-if="NOTARIA.Contacto.Email && NOTARIA.Contacto.Email2" :style="contactoLinkStyle"> | </span>
                      <a v-if="NOTARIA.Contacto.Email2" :style="contactoLinkStyle" :href="'mailto:' + NOTARIA.Contacto.Email2"
                        :title="'Enviar correo electronico a la dirección de la Notaria: ' + NOTARIA.Contacto.Email2">
                        {{ NOTARIA.Contacto.Email2 }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="social-share-inner mb-6">
                  <ul class="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                    <li v-if="NOTARIA.Contacto.Facebook">
                      <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Facebook" :title="'Ir a la página de Facebook de ' + NOTARIA.Nombre" :aria-label="'Facebook de ' + NOTARIA.Nombre">
                        <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-facebook</v-icon>
                      </a>
                    </li>
                    <li v-if="NOTARIA.Contacto.LinkedIn">
                      <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.LinkedIn" :title="'Ir a la página de LinkedIn de ' + NOTARIA.Nombre" :aria-label="'LinkedIn de ' + NOTARIA.Nombre">
                        <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-linkedin</v-icon>
                      </a>
                    </li>
                    <li v-if="NOTARIA.Contacto.Twitter">
                      <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Twitter" :title="'Ir a la página de Twitter de ' + NOTARIA.Nombre" :aria-label="'Twitter de ' + NOTARIA.Nombre">
                        <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-twitter</v-icon>
                      </a>
                    </li>
                    <li v-if="NOTARIA.Contacto.Instagram">
                      <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Instagram" :title="'Ir a la página de Instagram de ' + NOTARIA.Nombre" :aria-label="'Instagram de ' + NOTARIA.Nombre">
                        <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-instagram</v-icon>
                      </a>
                    </li>
                  </ul>
                </div>
              </v-col>
              <!-- End Single Widget  -->
            </v-row>
            <v-row>
              <v-col>
                <div>
                  <p>
                    <a :style="copyrightStyle" href="https://unidata.es">Copyright © {{ new Date().getFullYear() }}
                      UNIDATA</a> |
                    <a :style="copyrightStyle" href="https://controlpanel.notin.es/">{{ $t('panelControl') }}</a> |
                    <a :style="copyrightStyle" href="/avisolegal">{{ $t('avisoLegal') }}</a> |
                    <a :style="copyrightStyle" href="/politicacookies">{{ $t('politicaCookies') }}</a> |
                    <a :style="copyrightStyle" href="/protecciondatos">{{ $t('proteccionDatos') }}</a> |
                    <a :style="copyrightStyle" href="/accesibilidad">{{ $t('accesibilidad') }}</a> |
                    <a v-if="NOTARIA.Theme.Menu.ShowNV && NOTARIA.NotariaVirtual" :style="copyrightStyle" :href="NOTARIA.NotariaVirtualFrame ? '/NotariaVirtual':NOTARIA.NotariaVirtual" target="_blank">{{ getTitleNV() }}</a> |
                    <a v-if="NOTARIA.UrlDenuncias && NOTARIA.UrlDenuncias != ''" :style="copyrightStyle" :href="getURLDenuncias()">{{ $t('denuncias') }}</a>
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- End .col -->
      </v-row>
      <v-row v-if="NOTARIA.Theme.Footer.MostrarSubFooter">
        <v-col cols="12" class="pa-3 ">
          <FooterSubFooter />
        </v-col>
      </v-row>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { GoogleMap, Marker, InfoWindow } from 'vue3-google-map'
import { useStore } from '../../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)

import { useUtils } from '#imports';
const {imagenIDtoSRC,$t}=useUtils()

const colmd = computed(() => {
  if (NOTARIA.value && NOTARIA.value.Theme && !NOTARIA.value.Theme.Footer.MostrarMapa) {
    return 12
  }
  return 6
})
const window_open = ref(false)
const gmapOptions = ref({
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
  })
function getURLDenuncias()
{
  if(NOTARIA.value && NOTARIA.value.UrlDenuncias)
  {
    if(NOTARIA.value.UrlDenuncias.startsWith("https"))
    {
      return NOTARIA.value.UrlDenuncias 
    }else{
       return "https://"+ NOTARIA.value.UrlDenuncias 
    }
  }
}

function getTitleNV()
{
  if(!NOTARIA.value?.Theme?.Menu?.NameWeb)
  {
    return $t('NotariaVirtual') 
  } else {
    const nameWeb = NOTARIA.value.Theme.Menu.NameWeb.toUpperCase();
    if(nameWeb === "NOTARÍA VIRTUAL" || nameWeb === "NOTARIA VIRTUAL" || nameWeb === "NOTARIAVIRTUAL")
    {
      return $t('NotariaVirtual') 
    } else {
      return NOTARIA.value.Theme.Menu.NameWeb
    }
  }
}

function openWindow() {
  window_open.value = true
}
const horarioStyle = computed(() => ({
    display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.HorarioCSS.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Size ? NOTARIA.value.Theme.Footer.HorarioCSS.Size : '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Align ?? ''
}))

const tituloHorarioStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.TituloHorario.css.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Font ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Align ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Size ? NOTARIA.value.Theme.Footer.TituloHorario.css.Size : '',
}))

const contactoStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.ContactoCSS.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Align ?? ''
}))

const tituloContactoStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.TituloDContacto.css.BackgroundColor}`: '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Font ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Weight ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Size ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Align ?? ''
}))

const footerRightStyle = computed(() => ({
  background:
    NOTARIA.value?.Theme?.Footer?.FooterCSS ? 
      `linear-gradient(145deg,${NOTARIA.value.Theme.Footer.FooterCSS.BackgroundColor} 0%, ${NOTARIA.value.Theme.Footer.FooterCSS.BackgroundColorGradient} 100%)`
      : ''
}))

const footerLeftStyle = computed(() => ({
  background:
    NOTARIA.value?.Theme?.Footer?.MapaCSS ? 
    `linear-gradient(145deg,${NOTARIA.value.Theme.Footer.MapaCSS.BackgroundColor} 0%, ${NOTARIA.value.Theme.Footer.MapaCSS.BackgroundColorGradient} 100%)`
      : ''
}))
const copyrightStyle = computed(() => ({
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? ''
}))
const contactoLinkStyle = computed(() => ({
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? '',
  textDecoration: 'none'
}))
</script>
<style lang="scss">
.map-responsive {
  overflow: hidden; 
  position: relative;
  height: 400px;
}

.map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

@media (max-width: 1250px) {
  .footer-right-notin{
    padding: 15px !important;
  }
}
</style>